import {ADMIN_ROUTE_CONSTANTS} from '@shared/constants/routes';
import {MenuItem} from 'primeng/api';

const adminBase = `/${ADMIN_ROUTE_CONSTANTS.path}`;

export  const COMMUNITY: MenuItem = {
  label: ADMIN_ROUTE_CONSTANTS.community.data.breadcrumb,
  icon: ADMIN_ROUTE_CONSTANTS.community.data.icon,
  hasSubmenu: true,
  expanded: false,
  items: [
    {
      label: ADMIN_ROUTE_CONSTANTS.community.units.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.community.units.data.icon,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.community.path}/${ADMIN_ROUTE_CONSTANTS.community.units.path}`
    },
    {
      label: ADMIN_ROUTE_CONSTANTS.community.zones.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.community.zones.data.icon,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.community.path}/${ADMIN_ROUTE_CONSTANTS.community.zones.path}`
    },
    {
      label: ADMIN_ROUTE_CONSTANTS.community.councilAdministration.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.community.councilAdministration.data.icon,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.community.path}/${ADMIN_ROUTE_CONSTANTS.community.councilAdministration.path}`
    },
    {
      label: ADMIN_ROUTE_CONSTANTS.community.employees.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.community.employees.data.icon,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.community.path}/${ADMIN_ROUTE_CONSTANTS.community.employees.path}`
    },
    {
      label: 'MENU_ADMIN.COMMUNITY_SUB.COMMUNICATION',
      icon: 'fa-solid fa-comments',
      hasSubmenu: true,
      expanded: false,
      items: [
        {
          label: ADMIN_ROUTE_CONSTANTS.community.circularsSurveys.data.breadcrumb,
          icon: ADMIN_ROUTE_CONSTANTS.community.circularsSurveys.data.icon,
          routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.community.path}/${ADMIN_ROUTE_CONSTANTS.community.circularsSurveys.path}`
        },
        {
          label: ADMIN_ROUTE_CONSTANTS.community.chat.data.breadcrumb,
          icon: ADMIN_ROUTE_CONSTANTS.community.chat.data.icon,
          routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.community.path}/${ADMIN_ROUTE_CONSTANTS.community.chat.path}`
        }
      ]

    },

    {
      label: 'MENU_ADMIN.COMMUNITY_SUB.DOCUMENTS_LEGAL',
      icon: 'fa-solid fa-gavel',
      hasSubmenu: true,
      expanded: false,
      items: [
        {
          label: ADMIN_ROUTE_CONSTANTS.community.documentRepository.data.breadcrumb,
          icon: ADMIN_ROUTE_CONSTANTS.community.documentRepository.data.icon,
          routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.community.path}/${ADMIN_ROUTE_CONSTANTS.community.documentRepository.path}`
        },
        {
          label: ADMIN_ROUTE_CONSTANTS.community.legalCompliance.data.breadcrumb,
          icon: ADMIN_ROUTE_CONSTANTS.community.legalCompliance.data.icon,
          routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.community.path}/${ADMIN_ROUTE_CONSTANTS.community.legalCompliance.path}`
        }
      ]

    },
    {
      label: ADMIN_ROUTE_CONSTANTS.community.commonAreas.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.community.commonAreas.data.icon,
      hasSubmenu: false,
      expanded: false,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.community.path}/${ADMIN_ROUTE_CONSTANTS.community.commonAreas.path}`
    },

    {
      label: ADMIN_ROUTE_CONSTANTS.community.visitsSecurity.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.community.visitsSecurity.data.icon,
      hasSubmenu: false,
      expanded: false,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.community.path}/${ADMIN_ROUTE_CONSTANTS.community.visitsSecurity.path}`
    },


    {
      label: ADMIN_ROUTE_CONSTANTS.community.virtualAssembly.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.community.virtualAssembly.data.icon,
      hasSubmenu: false,
      expanded: false,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.community.path}/${ADMIN_ROUTE_CONSTANTS.community.virtualAssembly.path}`
    },
  ]
};


